/** Production: platform + lendicare + AI (origins only). */
export const LENDI_IFRAME_TRUSTED_ORIGINS_PROD =
  'https://platforma.lendi.pl https://platforma.lendicare.pl https://ai.lendi.pl'

/** Demo / staging. */
export const LENDI_IFRAME_TRUSTED_ORIGINS_DEMO =
  'https://platforma.demo.lendi.pl https://platforma.demo.lendicare.pl https://ai.qa.lendi.pl'

/** QA, Vercel previews, local dev. */
export const LENDI_IFRAME_TRUSTED_ORIGINS_QA =
  'https://platforma.qa.lendi.pl https://platforma.dev.lendicare.pl https://ai.qa.lendi.pl https://*.vercel.app http://127.0.0.1:8100 http://127.0.0.1:8080 http://localhost:8200 http://127.0.0.1:9000 http://localhost:9000'

function parseOriginList(raw: string): string[] {
  return raw
    .split(/[\s,]+/)
    .map(origin => origin.trim())
    .filter(Boolean)
}

const parsedPatternsCache = new Map<string, string[]>()

export function parseIframeTrustedOriginPatterns(raw: string): string[] {
  const cached = parsedPatternsCache.get(raw)
  if (cached) return cached
  const parsed = [...new Set(parseOriginList(raw))]
  parsedPatternsCache.set(raw, parsed)
  return parsed
}

/**
 * Returns true if `eventOrigin` matches any exact entry or `https://*.vercel.app`.
 */
export function isOriginAllowedByIframePatterns(
  eventOrigin: string,
  patterns: readonly string[],
): boolean {
  for (const pattern of patterns) {
    if (!pattern)
      continue
    if (pattern === eventOrigin)
      return true
    if (pattern === 'https://*.vercel.app' && isHttpsVercelAppOrigin(eventOrigin))
      return true
  }
  return false
}

function isHttpsVercelAppOrigin(origin: string): boolean {
  try {
    const parsedOrigin = new URL(origin)
    return (
      parsedOrigin.protocol === 'https:'
      && parsedOrigin.hostname.endsWith('.vercel.app')
    )
  }
  catch {
    return false
  }
}
